module.exports = __webpack_public_path__ + "static/media/table.d16d1303.jpg";